module.exports = __webpack_public_path__ + "static/media/Source Info.1304219c.txt";